import axios from "axios";
import { API_BASE_URL } from "../constants/api";
import { ACCESS_TOKEN } from "../constants/auth";

const FormService = {};
FormService.getMyForm = async () => {
  return axios({
    method: "get",
    url: API_BASE_URL + "/api/form/get/my",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  });
};

FormService.createForm = async (mainProfession, subProfession) => {
  let data = new FormData();
  data.append("mainProfession", mainProfession);
  data.append("subProfession", subProfession);
  return axios({
    method: "post",
    url: API_BASE_URL + "/api/form/create",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  });
};
export default FormService;
